import { Button } from '../../Utility/Button';
import Input from '../../Utility/FormElements/Input';
import AdminContainer from '../../Utility/AdminContainer';
import AdminBox from '../../Utility/AdminBox';
import ImageUpload from '../../Utility/ImageUpload';
import AdminBoxHeadline from '../../Utility/AdminBoxHeadline';
import useVoiceModel from '../../../Hooks/useVoiceModel';
import Select from '../../Utility/FormElements/Select';

function VoiceModel() {
    const {
        VoiceModelActions,
        voiceModelSnapshot,
        voiceModel,
        imagePreview,
        i18n,
        loadingState,
        voiceModelIdentifier,
        credentials,
    } = useVoiceModel();

    const handleSave = () => {
        VoiceModelActions.handleSave();
    };

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox contentLoaded={loadingState.modelLoaded && loadingState.credentialsLoaded}>
                    <div className="flex flex-col gap-5">
                        <AdminBoxHeadline
                            headLine={i18n.translate({
                                id: voiceModelIdentifier === 'new' ? 'newModel' : 'editModel',
                                sourceName: 'VoiceModel',
                            })}
                            subLine={voiceModelIdentifier === 'new' ? undefined : voiceModelSnapshot?.title}
                        />

                        <ImageUpload
                            handleImageChange={(e) => {
                                VoiceModelActions.handleImageChange(e);
                            }}
                            camRemoveImage={false}
                            imagePreview={imagePreview}
                        >
                            <Input
                                inputType="text"
                                value={voiceModel.title ?? ''}
                                onChange={(value) => VoiceModelActions.handleChangeModel('title', value)}
                                placeholder={i18n.translate({ id: 'placeholder.title', sourceName: 'VoiceModel' })}
                                className="w-full"
                            />
                        </ImageUpload>

                        <div>
                            <label className="block mb-2">
                                {i18n.translate({ id: 'title.modelName', sourceName: 'VoiceModel' })}
                            </label>
                            <Input
                                inputType="text"
                                value={voiceModel.value ?? ''}
                                onChange={(value) => VoiceModelActions.handleChangeModel('value', value)}
                                placeholder={i18n.translate({
                                    id: 'placeholder.modelName',
                                    sourceName: 'VoiceModel',
                                })}
                            />
                        </div>

                        <div>
                            <label className="block mb-2">
                                {i18n.translate({ id: 'title.credentials', sourceName: 'Model' })}
                            </label>
                            <Select
                                value={voiceModel.credential?.identifier ?? '---'}
                                onChange={VoiceModelActions.handleCredentialDropdownChange}
                            >
                                <option key="---" value="---">
                                    {i18n.translate({ id: 'option', sourceName: 'Main' })}
                                </option>
                                {credentials.map((credential) => (
                                    <option key={credential.identifier} value={credential.identifier}>
                                        {credential.name}
                                    </option>
                                ))}
                            </Select>
                        </div>

                        <div>
                            <label className="block mb-2">
                                {i18n.translate({
                                    id: 'title.type',
                                    sourceName: 'VoiceModel',
                                })}
                            </label>
                            <Select
                                value={voiceModel.type ?? ''}
                                onChange={(value) => VoiceModelActions.handleChangeModel('type', value || null)}
                            >
                                <option value="">
                                    {i18n.translate({ id: 'option', sourceName: 'Main' })}
                                </option>
                                <option value="transcribe">
                                    {i18n.translate({
                                        id: 'type.transcribe',
                                        sourceName: 'VoiceModel',
                                    })}
                                </option>
                                <option value="speech">
                                    {i18n.translate({
                                        id: 'type.speech',
                                        sourceName: 'VoiceModel',
                                    })}
                                </option>
                            </Select>
                        </div>

                        {voiceModel.type === 'transcribe' && (
                            <div className="mt-5">
                                <h5 className="mb-3">
                                    {i18n.translate({
                                        id: 'title.costs.transcribe',
                                        sourceName: 'VoiceModel',
                                    })}
                                </h5>
                                <div className="flex flex-col gap-5">
                                    <div>
                                        <label className="block mb-2">
                                            {i18n.translate({
                                                id: 'title.costTextInput',
                                                sourceName: 'VoiceModel',
                                            })}
                                        </label>
                                        <Input
                                            inputType="number"
                                            value={voiceModel.costTextInput ?? ''}
                                            onChange={(value) => VoiceModelActions.handleChangeModel('costTextInput', value)}
                                            inputProps={{ step: 0.00000001 }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-2">
                                            {i18n.translate({
                                                id: 'title.costTextOutput',
                                                sourceName: 'VoiceModel',
                                            })}
                                        </label>
                                        <Input
                                            inputType="number"
                                            value={voiceModel.costTextOutput ?? ''}
                                            onChange={(value) => VoiceModelActions.handleChangeModel('costTextOutput', value)}
                                            inputProps={{ step: 0.00000001 }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-2">
                                            {i18n.translate({
                                                id: 'title.costAudio',
                                                sourceName: 'VoiceModel',
                                            })}
                                        </label>
                                        <Input
                                            inputType="number"
                                            value={voiceModel.costAudio ?? ''}
                                            onChange={(value) => VoiceModelActions.handleChangeModel('costAudio', value)}
                                            inputProps={{ step: 0.00000001 }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {voiceModel.type === 'speech' && (
                            <div className="mt-5">
                                <h5 className="mb-3">
                                    {i18n.translate({
                                        id: 'title.costs.speech',
                                        sourceName: 'VoiceModel',
                                    })}
                                </h5>
                                <div className="flex flex-col gap-5">
                                    <div>
                                        <label className="block mb-2">
                                            {i18n.translate({
                                                id: 'title.costTextInput',
                                                sourceName: 'VoiceModel',
                                            })}
                                        </label>
                                        <Input
                                            inputType="number"
                                            value={voiceModel.costTextInput ?? ''}
                                            onChange={(value) => VoiceModelActions.handleChangeModel('costTextInput', value)}
                                            inputProps={{ step: 0.00000001 }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-2">
                                            {i18n.translate({
                                                id: 'title.costAudioOutput',
                                                sourceName: 'VoiceModel',
                                            })}
                                        </label>
                                        <Input
                                            inputType="number"
                                            value={voiceModel.costAudioOutput ?? ''}
                                            onChange={(value) => VoiceModelActions.handleChangeModel('costAudioOutput', value)}
                                            inputProps={{ step: 0.00000001 }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="mt-5 text-right">
                            <Button variant={'primary'} onClick={handleSave}>
                                {i18n.translate({ id: 'save', sourceName: 'Main' })}
                            </Button>
                        </div>
                    </div>
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default VoiceModel;
